import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared.module';
import { BimmoduleRoutingModule } from './bimmodule-routing.module';
import { NewenduserComponent } from './newenduser/newenduser.component';
import { ExistingenduserComponent } from './existingenduser/existingenduser.component';
// import { ProductlistComponent } from './productlist/productlist.component';
import { RaisecomplaintComponent } from './raisecomplaint/raisecomplaint.component';
import { CustomerDashboardComponent } from './customer-dashboard/customer-dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CusRegisteredComponent } from './cus-registered/cus-registered.component';
import { CusUnregisteredComponent } from './cus-unregistered/cus-unregistered.component';
import { MatRadioModule } from '@angular/material/radio';
import { LogoutComponent } from './logout/logout.component';
import { AssetstatusreportComponent } from '../report-module/assetstatusreport/assetstatusreport.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AllticketComponent } from '../report-module/allticket/allticket.component';
import {DateSelectionComponent} from '../trcadminmodule/daterangeselection/date-range-selection.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PmsProfileReportComponent } from '../report-module/pms-profile-report/pms-profile-report.component';
// import { CusRegisteredComponent } from './cus-registered/cus-registered.component';
// import { CusUnregisteredComponent } from './cus-unregistered/cus-unregistered.component';


@NgModule({
  declarations: [
    NewenduserComponent,
    ExistingenduserComponent,
    // ProductlistComponent,
    RaisecomplaintComponent,
    CustomerDashboardComponent,
    CusRegisteredComponent,
    CusUnregisteredComponent,
    LogoutComponent,
    AssetstatusreportComponent,
    AllticketComponent,
    DateSelectionComponent,
    PmsProfileReportComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    BimmoduleRoutingModule,
    ReactiveFormsModule, // ✅ Add this
    FormsModule, // (Optional, for template-driven forms)
    NgxPaginationModule,
    // DateSelectionComponent,
    NgbModule
  ],
  exports:[DateSelectionComponent],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
  
  // CUSTOM_ELEMENTS_SCHEMA
})
export class BimmoduleModule { }
// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { SharedModule } from '../shared.module';
// import { BimmoduleRoutingModule } from './bimmodule-routing.module';
// import { NewenduserComponent } from './newenduser/newenduser.component';
// import { ExistingenduserComponent } from './existingenduser/existingenduser.component';
// import { ProductlistComponent } from './productlist/productlist.component';
// import { RaisecomplaintComponent } from './raisecomplaint/raisecomplaint.component';
// import { CustomerDashboardComponent } from './customer-dashboard/customer-dashboard.component';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { CusRegisteredComponent } from './cus-registered/cus-registered.component';
// import { CusUnregisteredComponent } from './cus-unregistered/cus-unregistered.component';
// import { MatRadioModule } from '@angular/material/radio';
// import { LogoutComponent } from './logout/logout.component';
// import { NgxOrgChartModule } from 'ngx-org-chart';
// import { AccumulationChartModule, ChartModule } from '@syncfusion/ej2-angular-charts';
// import { CusRegisteredComponent } from './cus-registered/cus-registered.component';
// import { CusUnregisteredComponent } from './cus-unregistered/cus-unregistered.component';


// @NgModule({
//   declarations: [
//     // CusUnregisteredComponent
//   // CusRegisteredComponent
//     NewenduserComponent,
//     ExistingenduserComponent,
//     // ProductlistComponent,
//     RaisecomplaintComponent,
//     CustomerDashboardComponent,
//     CusRegisteredComponent,
//     CusUnregisteredComponent,
//     LogoutComponent
//   ],
//   imports: [
//     SharedModule,
//     CommonModule,
//     BimmoduleRoutingModule,
//     FormsModule,
//     ReactiveFormsModule,  // ✅ Ensure this is included
//     MatRadioModule,
//     // AccumulationChartModule,
//     // NgxOrgChartModule,
//     // ChartModule
//   ]
//   // ,exports:[NgxOrgChartModule,                        // module for chart
// 	// 	ChartModule,// module for chart
// 	//   AccumulationChartModule,]
// })
// // export class BimmoduleModule { }

